export enum OnboardingStep {
  ONBOARD_USER = 'ONBOARD_USER',
  SELECT_TENANT = 'SELECT_TENANT',
  VALUE_PROPOSITION = 'VALUE_PROPOSITION',
  LOGIN = 'LOGIN'
}
